import { render } from "./PrintAndUpload.vue?vue&type=template&id=1807c6b7&scoped=true"
import script from "./PrintAndUpload.vue?vue&type=script&lang=js"
export * from "./PrintAndUpload.vue?vue&type=script&lang=js"

import "./PrintAndUpload.vue?vue&type=style&index=0&id=1807c6b7&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\eNotary.SPA\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1807c6b7"]])

export default __exports__